require('./bootstrap');
import Alpine from 'alpinejs';
window.Alpine = Alpine;

import mask from '@alpinejs/mask';
Alpine.plugin(mask)

import * as FilePond from 'filepond';
window.FilePond = FilePond;

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
FilePond.registerPlugin(FilePondPluginFileValidateType);

import Pikaday from 'pikaday';
window.Pikaday = Pikaday;

// import 'livewire-sortable'

import '@nextapps-be/livewire-sortablejs';

import 'croppie/croppie.css';

import Croppie from 'croppie';
window.Croppie = Croppie;

import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'

import * as Ladda from 'ladda';
Ladda.bind('button[type=submit],a[type=submit]');

window.addEventListener('updateState', event => {
  Ladda.bind('button[type=submit],a[type=submit]');
})

window.setupEditor = function (content) {
  return {
    editor: null,
    content: content,

    init(element) {
      this.editor = new Editor({
        element: element,
        extensions: [
          StarterKit,
        ],
        content: this.content,
        onUpdate: ({ editor }) => {
          this.content = editor.getHTML()
        }
      })

      this.$watch('content', (content) => {
        if (content === this.editor.getHTML()) return

        this.editor.commands.setContent(content, false)
      })
    }
  }
}


Alpine.start();